<script setup lang="ts">
import { ref } from 'vue'
import { updateOfferExpirationAction } from '@/api/functions/settings/update-offer-expiration-action'
import { useMutationApi } from '@/composables/useApi'
import { useToast } from '@/composables/useToast'
import { settingsTabs } from '@/constants/setting-tabs.ts'
import { getErrorMessage } from '@/utils/errorUtils'
import SettingsOverview from './partials/SettingsOverview.vue'

const validity = ref<number | null>(8)

const toast = useToast()

const updateValidityMutation = useMutationApi({
  mutationFn: (payload: { offer_expiration_value: number }) => updateOfferExpirationAction(payload),
  onSuccess: () => {
    toast.success('مدت اعتبار پیشنهاد با موفقیت بروزرسانی شد')
  },
  onError: (error: Error) => {
    toast.error(getErrorMessage(error), 'خطا')
  },
})

const onSubmit = (e: Event) => {
  e.preventDefault()
  if (!validity.value || validity.value <= 0) {
    toast.error('لطفاً یک مقدار معتبر وارد کنید', 'خطا')
    return
  }
  updateValidityMutation.mutate({ offer_expiration_value: Number(validity.value) })
}
</script>

<template>
    <div class="w-full mb-12">
        <SettingsOverview :tabs="settingsTabs" />
        <form @submit="onSubmit"
            class="h-[91px] flex items-center justify-between p-4 bg-white border border-[#d8d8d8] rounded-xl mt-8">
            <div class="flex items-center gap-4">
                <span class="text-[#1b325a] text-[15px] whitespace-nowrap">مدت اعتبار پیشنهاد (ساعت)</span>
                <Input v-model="validity" name="amount" type="number" class="h-[50px]!" />
            </div>

            <Button type="submit" label="اعمال" :isAdmin="true" class="w-[150px]! text-base h-12! rounded-[10px]!"
                :loading="updateValidityMutation.isPending.value"
                :disabled="!validity || updateValidityMutation.isPending.value" />
        </form>
    </div>
</template>
